import React from 'react';
import { Link } from 'react-router-dom';

const Industries = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <h2>Industries We Serve</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-md-6">
        <div>
          <h5><b>Overview</b></h5>
          <hr />
          <p>Groundbreaking solutions evolve on a thorough understanding of the client industry – business models, specific challenges, technological landscape and the market context in which they are working. 
          </p>
          <p>Whether we are building core analytics solutions for a financial enterprise or helping a transportation or Wholesale company digitize from scratch, we put forward domain expertise, decades of experience and a passion for the client’s success.
          </p>
          <p>Techarabiya team has vast experience in serving clients. We help you make the big switch from traditional methods to the more efficient digital methods. You can count on our decade worth of practical experience for successful deployment of digital solutions and services for your business.
          </p>
          <h5><b>Industry focus:</b></h5>
          <hr />
          <ul className="list-check list-unstyled">
            <li><i className="far fa-check-circle" />Islamic Banking and Finance</li>
            <li> <i className="far fa-check-circle" />Automotive Industry</li>
            <li><i className="far fa-check-circle" />Real Estate Industry</li>
            <li><i className="far fa-check-circle" />Retail &amp; Wholesale</li>
          </ul>
        </div>
      </div>
      <div className="col-sm-12 col-md-6">
        <img src="img/industries-we-serve.png" className="img-fluid service-image" />
      </div>
    </div>
  </div>
  <div className="container">
    {/* Pricing NavTab Begin */}
    <div className="pricing-navtab">
      {/* Pricing Nav Begin */}
      <ul className="row nav nav-tabs" role="tablist">
        {/* Single Nav Begin */}
        <li className="nav-item col-lg-3 col-sm-6">
          <a href="#personal" className="nav-link text-center active" data-toggle="tab" role="tab" style={{padding: '37px'}}>
            <h4>Islamic Banking &amp; Finance</h4>
          </a>
        </li>
        {/* Single Nav End */}
        {/* Single Nav Begin */}
        <li className="nav-item col-lg-3 col-sm-6">
          <a href="#startup" className="nav-link text-center" data-toggle="tab" role="tab">
            <h4>Automotive Industry</h4>
          </a>
        </li>
        {/* Single Nav End */}
        {/* Single Nav Begin */}
        <li className="nav-item col-lg-3 col-sm-6">
          <a href="#business" className="nav-link text-center" data-toggle="tab" role="tab">
            <h4>Real Estate Industry</h4>
          </a>
        </li>
        {/* Single Nav End */}
        {/* Single Nav Begin */}
        <li className="nav-item col-lg-3 col-sm-6">
          <a href="#entrepreneur" className="nav-link text-center" data-toggle="tab" role="tab">
            <h4>Retail &amp; Wholesale</h4>
          </a>
        </li>
        {/* Single Nav End */}
      </ul>
      {/* Pricing Nav End */}
      {/* Pricing Tab Content Begin */}
      <div className="tab-content">
        {/* Single Content Begin */}
        <div className="tab-pane fadeInUp animated show active" id="personal" role="tabpanel">
          <div className="row">
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text mt-50 mt-lg-0">
                <p>Techarabiya enable Islamic Financial Institutions to attract more customers, increase efficiency, reduce costs and offer a wider range of products, helping the sector become more competitive without any sort of compromises.</p>
                <p>Techarabiya team consists of market-leading Islamic banking practitioners and their experience represents a breadth of knowledge and expertise unparalleled in the market.</p>
                <p>Expanding sharia-compliant financial services.</p>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <h4>We offer:</h4>
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> Islamic Finance Products Advisory Services</li>
                  <li><i className="far fa-check-circle" /> Islamic Product Development</li>
                  <li><i className="far fa-check-circle" /> Setting up Sharia Compliant Digital Bank</li>
                  <li><i className="far fa-check-circle" /> Digital Wallets</li>
                  <li><i className="far fa-check-circle" /> Islamic Payments &amp; Remittance Solutions</li>
                  <li><i className="far fa-check-circle" /> Sharia Advisory </li>
                  <li><i className="far fa-check-circle" /> Mortgage Echo System </li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> Automotive Eco System</li>
                  <li><i className="far fa-check-circle" /> Process Re-Engineering &amp; Optimization</li>
                  <li><i className="far fa-check-circle" /> Islamic Risk Advisory</li>
                  <li><i className="far fa-check-circle" /> Setting up Sharia Compliant Policy &amp; Procedure </li>
                  <li><i className="far fa-check-circle" /> Islamic Securitization</li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
          </div>
        </div>
        {/* Single Content End */}
        {/* Single Content Begin */}
        <div className="tab-pane fadeInUp animated" id="startup" role="tabpanel">
          <div className="row">
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text mt-50 mt-lg-0">
                <p>Techarabiya experts have their hands firmly on the pulse of the automotive industry, with unmatched expertise in vehicle services, and digital and software solutions for automotive dealers. Dedication, drive and commitment to improving the automotive industry serve as a guiding force as we continue to transform the way the world buys, sells, owns and uses cars.</p>
                <p>Born from an idea to connect pillars of automotive industry into one, unified game changer, Techarabiya is uniquely positioned to transform the way the world buys, sells, owns and uses cars including F&amp;I. </p>
                <p>We are connecting what’s needed with what’s next to empower our clients to thrive in a rapidly changing automotive marketplace. We focus on continually improving our products to create faster vehicle transactions, enabling consumers to have a seamless online-to-offline digital experience. </p>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <h4>We offer:</h4>
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> Automtoive ecosystem</li>
                  <li><i className="far fa-check-circle" /> Dealer Management Systems</li>
                  <li><i className="far fa-check-circle" /> Finance &amp; Insurance Origination System</li>
                  <li><i className="far fa-check-circle" /> Rule Engine (Decisioning Engine) </li>
                  <li><i className="far fa-check-circle" /> Inventory Management</li>
                  <li><i className="far fa-check-circle" /> Digital Sales</li>
                  <li><i className="far fa-check-circle" /> KPI Monitor </li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> Campaign &amp; Promotions Catalogue</li>
                  <li><i className="far fa-check-circle" /> Process Re-Engineering &amp; Optimization</li>
                  <li><i className="far fa-check-circle" /> e-Contracting </li>
                  <li><i className="far fa-check-circle" /> Invoicing </li>
                  <li><i className="far fa-check-circle" /> Automotive Analytics</li>
                  <li><i className="far fa-check-circle" /> Automotive Marketplace</li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
          </div>
        </div>
        {/* Single Content End */}
        {/* Single Content Begin */}
        <div className="tab-pane fadeInUp animated" id="business" role="tabpanel">
          <div className="row">
            <div className="col-lg-6">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text mt-50 mt-lg-0">
                <p><b>Digitization shakes up the real estate business. A new ecosystem for a better experience when looking for a home</b></p>
                <p>Now it’s the real estate sector´s turn. The housing market has some new dwellers disrupting the game. Techarabiya experts have their hands firmly on the pulse of the Real Estate industry, with unmatched expertise to innovate and add value to the real estate business through technology. </p>
                <p>Techarabiya lead this revolution and plays an important role in the real estate business transformation by offering cutting-edge digital solution to have mesmerizing seamless real estate customer´s experience.</p>
                <p>We are connecting what’s needed with what’s next to empower our clients to thrive in a rapidly changing real estate marketplace. We focus on continually improving our products to create faster transactions, enabling consumers to have a seamless online-to-offline digital experience. </p>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-6">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <h4>We offer:</h4>
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> Real Estate ecosystem</li>
                  <li><i className="far fa-check-circle" /> Brokers &amp; Developer Management System</li>
                  <li><i className="far fa-check-circle" /> Finance &amp; Insurance Origination System</li>
                  <li><i className="far fa-check-circle" /> Rule Engine (Decisioning Engine</li>
                  <li><i className="far fa-check-circle" /> Inventory Management</li>
                  <li><i className="far fa-check-circle" /> Digital Sales </li>
                  <li><i className="far fa-check-circle" /> KPI Monitor </li>
                  <li><i className="far fa-check-circle" /> Campaign &amp; Promotions Catalogue</li>
                  <li><i className="far fa-check-circle" /> e-Contracting</li>
                  <li><i className="far fa-check-circle" /> Invoicing</li>
                  <li><i className="far fa-check-circle" /> Analytics</li>
                  <li><i className="far fa-check-circle" /> Real Estate Marketplace</li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
          </div>
        </div>
        {/* Single Content End */}
        {/* Single Content Begin */}
        <div className="tab-pane fadeInUp animated" id="entrepreneur" role="tabpanel">
          <div className="row">
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text mt-50 mt-lg-0">
                <p>Technology is now revolutionizing the retail industry. It shapes the way customers interact with brands and offers smarter tools for businesses to boost engagement grow customer loyalty and increase sales. </p>
                <p>We help retailers, consumer-goods companies and manufacturers to monetize on digital disruption with the capabilities of Data Science, Artificial Intelligence, Augmented Reality, Mobile and IoT, blockchain and more. </p>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <h4>We offer:</h4>
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> Customer Experience &amp; Engagement</li>
                  <li><i className="far fa-check-circle" /> Ecommerce platform</li>
                  <li><i className="far fa-check-circle" /> Enterprise systems</li>
                  <li><i className="far fa-check-circle" /> Mobile applications</li>
                  <li><i className="far fa-check-circle" /> Social media</li>
                  <li><i className="far fa-check-circle" /> Web stores</li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
            <div className="col-lg-4">
              {/* Tab Pane Text Begin */}
              <div className="tab-pane-text">
                <ul className="list-unstyled list-check">
                  <li><i className="far fa-check-circle" /> B2C &amp; B2B Marketplaces</li>
                  <li><i className="far fa-check-circle" /> E-Auctions</li>
                  <li><i className="far fa-check-circle" /> Online Shopping Carts</li>
                  <li><i className="far fa-check-circle" /> Social Commerce</li>
                  <li><i className="far fa-check-circle" /> E-Procurement</li>
                </ul>
              </div>
              {/* Tab Pane Text End */}
            </div>
          </div>
        </div>
        {/* Single Content End */}
      </div>
      {/* Pricing Tab Content End */}
    </div>
    {/* Pricing NavTab End */}
  </div>
</div>

<div className="container contactus">
  <div className="row mb-5 mt-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
      
        
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>

            
        </div>
    )
}

export default Industries
